import usePrivateAxios from "@/common/api/usePrivateAxios";
import { RewardItemData, RewardItemResponse } from "@/common/types/rewardItems";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

const useRewardItem: (id: string) => UseQueryResult<RewardItemData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<RewardItemResponse, unknown, RewardItemData>({
    queryKey: ['rewardItem', id],
    queryFn: () => privateAxios.get(`/tmais/products/${id}`),
    select: (data) => data?.data?.data
  });
};

export default useRewardItem;
